import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Popover } from 'antd'
import { QRCodeSVG } from 'qrcode.react'
import styles from './qr-code-download-banner.scss'
import ArrowRightOutlinedIcon from 'assets/icons/icon-arrow-right-outlined.svg'
import SvgIcon from 'src/components/common/SvgIcon'
import CancelIcon from 'assets/icons/ico-close.svg'
import queryString from 'query-string'
import { branchFloatingButtonLinkSelector } from 'src/selectors'
import { connect } from 'react-redux'

const QRCodeDownloadBanner = ({
  onClose,
  title,
  bannerClassName,
  placement = 'bottomRight',
  showCloseIcon = false,
  eventToken,
  invitationToken,
  baseUrl,
  branchLink
}) => {
  const resolvedBaseUrl = baseUrl || branchLink || ''
  const params = {}
  if (eventToken) params.event_token = eventToken
  if (invitationToken) params.invitation_token = invitationToken

  const downloadUrl = Object.keys(params).length > 0
    ? `${resolvedBaseUrl}?${queryString.stringify(params)}`
    : resolvedBaseUrl

  return (
    <div className={classnames(styles['download-app-banner'], bannerClassName)}>
      <div className={styles['download-app-banner-title']}>
        {title}
      </div>
      <div className={styles['download-app-banner-qr-code']}>
        <div className={styles['scan-qr-code']}>
          <div>Scan QR code</div>
          <SvgIcon className={styles['scan-qr-code-icon']} icon={ArrowRightOutlinedIcon} width="12" />
        </div>
        <div className={styles['qr-code-placeholder']}>
          <Popover
            content={
              <QRCodeSVG value={downloadUrl} size={208} />
            }
            placement={placement}
            trigger="hover"
          >
            <QRCodeSVG value={downloadUrl} size={40} style={{ cursor: 'pointer' }} />
          </Popover>
        </div>
      </div>
      {
        showCloseIcon && (
          <div className={styles['close-icon-wrapper']} onClick={onClose}>
            <SvgIcon className={styles['close-icon']} icon={CancelIcon} width="16" />
          </div>
        )
      }
    </div>
  )
}

QRCodeDownloadBanner.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  showCloseIcon: PropTypes.bool,
  bannerClassName: PropTypes.string,
  placement: PropTypes.string,
  eventToken: PropTypes.string,
  invitationToken: PropTypes.string,
  baseUrl: PropTypes.string,
  branchLink: PropTypes.string
}

function mapStateToProps(state) {
  return {
    branchLink: branchFloatingButtonLinkSelector(state)
  }
}

export default connect(mapStateToProps)(QRCodeDownloadBanner)
